module.exports = __webpack_public_path__ + "static/ethno-5ccd0b88017c73d63d29a6b5aa1502bf.png";